import { render, staticRenderFns } from "./VerticalImageWidget.vue?vue&type=template&id=1e4f77ae&"
import script from "./VerticalImageWidget.vue?vue&type=script&lang=js&"
export * from "./VerticalImageWidget.vue?vue&type=script&lang=js&"
import style0 from "./VerticalImageWidget.vue?vue&type=style&index=0&id=1e4f77ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports